import type { FindingType, Inspection, NewInspection } from "./types.ts";
import { supabase } from "./supabase.ts";

export async function listInspectionsFor(hydrantId: string): Promise<Inspection[]> {
  const { data, error } = await supabase
    .from("inspections")
    .select("*, inspection_findings(code, note, finding_types(label, category, sort))")
    .eq("hydrant_id", hydrantId)
    .order("inspected_at", { ascending: false });
  if (error) throw error;
  return data ?? [];
}

let findingTypesCache: FindingType[] | null = null;

export async function listFindingTypes(): Promise<FindingType[]> {
  if (findingTypesCache) return findingTypesCache;
  const { data, error } = await supabase.from("finding_types").select("*").order("sort");
  if (error) throw error;
  findingTypesCache = data ?? [];
  return findingTypesCache;
}

export async function createInspection(
  inspection: NewInspection,
  findingCodes: string[] = [],
): Promise<Inspection> {
  const { data, error } = await supabase
    .from("inspections")
    .insert(inspection)
    .select()
    .single();
  if (error) throw error;
  if (findingCodes.length > 0) {
    const { error: fErr } = await supabase
      .from("inspection_findings")
      .insert(findingCodes.map((code) => ({ inspection_id: data.id, code })));
    if (fErr) throw fErr;
  }
  return data;
}
